let counter = -1;

export const generateTempId = (): number => counter--;
